import React from "react";
import useLoginLogic from "../components/LoginForm";
import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import TransitionOverlay from "../components/TransitionOverlay";

const Login = () => {
  const { formData, handleChange, handleSubmit, error, showTransition, handleTransitionComplete } = useLoginLogic();
  const [showPassword, setShowPassword] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [googleTransition, setGoogleTransition] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) window.location.href = "/";
  }, []);

  useEffect(() => {
    localStorage.removeItem("unverifiedEmail");
    localStorage.removeItem("verificationType");
    localStorage.removeItem("emailConfirmed");
    requestAnimationFrame(() => setTimeout(() => setLoaded(true), 50));
  }, []);

  const handleGoogleLogin = (credentialResponse) => {
    const token = credentialResponse.credential;
    fetch("https://awaretherapycenter.ro/accounts/google-login/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    })
      .then((res) => res.json())
      .then((data) => {
        localStorage.setItem("access_token", data.access);
        localStorage.setItem("refresh_token", data.refresh);
        if (data.user) {
          localStorage.setItem("user_first_name", data.user.first_name);
          localStorage.setItem("user_last_name", data.user.last_name);
        }
        setGoogleTransition(true);
      })
      .catch((err) => console.error("Eroare login Google:", err));
  };

  const css = `
    @import url('https://fonts.googleapis.com/css2?family=Cormorant:ital,wght@0,300;0,400;0,500;1,300;1,400&family=Inter:wght@300;400;500&display=swap');

    /* ═══ NAV ═══ */
    .al-nav {
      position: fixed; top: 0; left: 0; right: 0;
      z-index: 100;
      background: rgba(250,247,242,0.92);
      backdrop-filter: blur(30px);
      -webkit-backdrop-filter: blur(30px);
    }
    .al-nav-inner {
      max-width: 1400px; margin: 0 auto;
      padding: 28px 48px;
      display: flex; align-items: center; justify-content: space-between;
    }
    .al-nav-logo {
      font-family: 'Cormorant', Georgia, serif;
      font-size: 22px; font-weight: 400;
      letter-spacing: 5px; text-transform: uppercase;
      color: #074F4F;
      text-decoration: none;
    }
    .al-nav-links { display: flex; gap: 44px; list-style: none; padding: 0; margin: 0; }
    .al-nav-links a {
      font-family: 'Inter', sans-serif;
      font-size: 12px; font-weight: 500;
      letter-spacing: 2px; text-transform: uppercase;
      color: #2d2d2d;
      text-decoration: none;
      transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
      position: relative;
      padding-bottom: 4px;
    }
    .al-nav-links a::after {
      content: '';
      position: absolute;
      bottom: 0; left: 0;
      width: 100%; height: 1px;
      background: #074F4F;
      transform: scaleX(0);
      transform-origin: right;
      transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .al-nav-links a:hover::after { transform: scaleX(1); transform-origin: left; }
    .al-nav-links a:hover { color: #074F4F; }
    .al-nav-auth { display: flex; align-items: center; gap: 20px; }
    .al-nav-reg {
      font-family: 'Inter', sans-serif;
      font-size: 11px; font-weight: 500;
      letter-spacing: 2px; text-transform: uppercase;
      color: #074F4F;
      background: transparent;
      border: 1px solid #C6A769;
      padding: 10px 24px;
      text-decoration: none;
      transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
      position: relative; overflow: hidden;
    }
    .al-nav-reg::before {
      content: '';
      position: absolute; inset: 0;
      background: #C6A769;
      transform: translateY(101%);
      transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .al-nav-reg:hover::before { transform: translateY(0); }
    .al-nav-reg span { position: relative; z-index: 1; }
    .al-nav-toggle {
      display: none; flex-direction: column; justify-content: center; align-items: center;
      gap: 5px; width: 40px; height: 40px; background: none; border: none; cursor: pointer; z-index: 210;
    }
    .al-nav-toggle span { display: block; width: 24px; height: 1.5px; background: #074F4F; transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1); }
    .al-nav-toggle.open span:nth-child(1) { transform: translateY(6.5px) rotate(45deg); }
    .al-nav-toggle.open span:nth-child(2) { opacity: 0; }
    .al-nav-toggle.open span:nth-child(3) { transform: translateY(-6.5px) rotate(-45deg); }
    .al-nav-mobile {
      display: none; flex-direction: column; background: #FAF7F2; max-height: 0; overflow: hidden;
      transition: max-height 0.5s cubic-bezier(0.16, 1, 0.3, 1); box-shadow: 0 12px 30px rgba(7,79,79,0.1);
    }
    .al-nav-mobile.open { max-height: 400px; }
    .al-nav-mobile-links { list-style: none; display: flex; flex-direction: column; padding: 12px 24px; margin: 0; }
    .al-nav-mobile-links li { border-bottom: 1px solid rgba(7,79,79,0.06); }
    .al-nav-mobile-links li:last-child { border-bottom: none; }
    .al-nav-mobile-links a {
      display: block; padding: 16px 4px; font-family: 'Inter', sans-serif; font-size: 14px; font-weight: 500;
      letter-spacing: 1px; text-transform: uppercase; color: #2d2d2d; text-decoration: none;
    }
    .al-nav-mobile-links a:hover { color: #074F4F; }
    .al-nav-mobile-auth { padding: 16px 24px 28px; }
    .al-nav-mobile-auth .al-nav-reg { display: block; text-align: center; }
    .al-nav-mobile-scrim {
      position: fixed; inset: 0; z-index: 90; background: rgba(7,79,79,0.3);
      opacity: 0; visibility: hidden; transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .al-nav-mobile-scrim.open { opacity: 1; visibility: visible; }

    /* ═══ FOOTER ═══ */
    .al-footer {
      background: #074F4F;
      padding: 80px 48px 32px;
    }
    .al-f-inner { max-width: 1200px; margin: 0 auto; }
    .al-f-grid {
      display: grid;
      grid-template-columns: 2fr 1fr 1fr 1fr;
      gap: 48px; margin-bottom: 56px;
    }
    .al-f-brand-name {
      font-family: 'Cormorant', Georgia, serif;
      font-size: 22px; font-weight: 400;
      letter-spacing: 5px; text-transform: uppercase;
      color: #FAF7F2; margin-bottom: 14px;
    }
    .al-f-brand p {
      font-family: 'Inter', sans-serif;
      font-size: 13px; line-height: 1.7;
      color: rgba(250,247,242,0.4); max-width: 260px;
    }
    .al-f-social {
      display: flex; gap: 16px; margin-top: 24px;
    }
    .al-f-social a {
      width: 36px; height: 36px;
      border: 1px solid rgba(198,167,105,0.25);
      border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      font-family: 'Inter', sans-serif;
      font-size: 11px; letter-spacing: 1px;
      text-transform: uppercase;
      color: rgba(250,247,242,0.5);
      text-decoration: none;
      transition: all 0.3s;
    }
    .al-f-social a:hover {
      background: #C6A769; border-color: #C6A769;
      color: #074F4F;
    }
    .al-f-col h5 {
      font-family: 'Inter', sans-serif;
      font-size: 10px; font-weight: 500;
      letter-spacing: 2px; text-transform: uppercase;
      color: #C6A769; margin-bottom: 20px;
    }
    .al-f-col ul { list-style: none; padding: 0; margin: 0; }
    .al-f-col li { margin-bottom: 12px; }
    .al-f-col a {
      font-family: 'Inter', sans-serif;
      font-size: 13px; color: rgba(250,247,242,0.4);
      text-decoration: none;
      transition: color 0.3s;
    }
    .al-f-col a:hover { color: #C6A769; }
    .al-f-divider {
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(198,167,105,0.2), transparent);
      margin-bottom: 32px;
    }
    .al-f-bottom {
      display: flex; justify-content: space-between;
      font-family: 'Inter', sans-serif;
      font-size: 11px; color: rgba(250,247,242,0.25);
    }
    .al-f-bottom a { color: rgba(250,247,242,0.25); margin-left: 20px; text-decoration: none; transition: color 0.3s; }
    .al-f-bottom a:hover { color: #C6A769; }

    /* ═══ SCENE ═══ */
    .al-scene {
      min-height: 100vh;
      padding-top: 100px;
      padding-bottom: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      overflow: hidden;
      background: #FAF7F2;
    }
    .al-scene::before {
      content: '';
      position: absolute;
      top: -20%; right: -10%;
      width: 600px; height: 600px;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(218,235,219,0.25) 0%, transparent 70%);
      pointer-events: none;
    }
    .al-scene::after {
      content: '';
      position: absolute;
      bottom: -15%; left: -8%;
      width: 500px; height: 500px;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(245,225,208,0.2) 0%, transparent 70%);
      pointer-events: none;
    }

    /* grain */
    .al-grain {
      position: fixed; inset: 0; z-index: 10;
      pointer-events: none; opacity: 0.02;
      background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
      background-size: 128px;
    }

    /* layout */
    .al-layout {
      max-width: 1100px;
      width: 100%;
      margin: 0 auto;
      padding: 60px 48px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 80px;
      align-items: center;
      position: relative;
      z-index: 2;
    }

    /* ─── LEFT: BRAND ─── */
    .al-brand {
      opacity: 0;
      transform: translateY(40px);
      transition: all 1s cubic-bezier(0.16, 1, 0.3, 1) 0.2s;
    }
    .al-scene.loaded .al-brand {
      opacity: 1;
      transform: translateY(0);
    }
    .al-brand-tag {
      font-family: 'Inter', sans-serif;
      font-size: 10px; font-weight: 500;
      letter-spacing: 4px; text-transform: uppercase;
      color: #C6A769;
      margin-bottom: 24px;
    }
    .al-brand h1 {
      font-family: 'Cormorant', Georgia, serif;
      font-size: clamp(40px, 5vw, 64px);
      font-weight: 300;
      color: #074F4F;
      line-height: 1.05;
      letter-spacing: -0.03em;
      margin-bottom: 28px;
    }
    .al-brand h1 em {
      font-style: italic;
      font-weight: 300;
      color: #C6A769;
    }
    .al-brand-line {
      width: 60px; height: 1px;
      background: #C6A769;
      margin-bottom: 28px;
      transform: scaleX(0); transform-origin: left;
      transition: transform 1s cubic-bezier(0.16, 1, 0.3, 1) 0.6s;
    }
    .al-scene.loaded .al-brand-line {
      transform: scaleX(1);
    }
    .al-brand-quote {
      font-family: 'Cormorant', Georgia, serif;
      font-size: 20px;
      font-weight: 300;
      font-style: italic;
      line-height: 1.6;
      color: #8a8a8a;
      max-width: 380px;
    }
    .al-brand-author {
      margin-top: 16px;
      font-family: 'Inter', sans-serif;
      font-size: 10px;
      letter-spacing: 3px;
      text-transform: uppercase;
      color: #b5b5b5;
    }

    /* ─── RIGHT: FORM CARD ─── */
    .al-form-wrap {
      opacity: 0;
      transform: translateY(40px);
      transition: all 1s cubic-bezier(0.16, 1, 0.3, 1) 0.4s;
    }
    .al-scene.loaded .al-form-wrap {
      opacity: 1;
      transform: translateY(0);
    }
    .al-card {
      background: #fff;
      padding: 56px 48px;
      position: relative;
      box-shadow:
        0 1px 3px rgba(7,79,79,0.02),
        0 8px 32px rgba(7,79,79,0.04),
        0 24px 60px rgba(7,79,79,0.03);
    }
    .al-card::before {
      content: '';
      position: absolute;
      top: 0; left: 0; right: 0;
      height: 2px;
      background: #C6A769;
      transform: scaleX(0); transform-origin: left;
      transition: transform 1.2s cubic-bezier(0.16, 1, 0.3, 1) 0.8s;
    }
    .al-scene.loaded .al-card::before {
      transform: scaleX(1);
    }

    .al-card-head {
      margin-bottom: 36px;
    }
    .al-card-head h2 {
      font-family: 'Cormorant', Georgia, serif;
      font-size: 32px;
      font-weight: 300;
      color: #074F4F;
      letter-spacing: -0.02em;
      margin-bottom: 6px;
    }
    .al-card-head p {
      font-family: 'Inter', sans-serif;
      font-size: 13px;
      font-weight: 300;
      color: #8a8a8a;
    }

    /* inputs */
    .al-field {
      margin-bottom: 24px;
    }
    .al-label {
      display: block;
      font-family: 'Inter', sans-serif;
      font-size: 9px; font-weight: 500;
      letter-spacing: 3px;
      text-transform: uppercase;
      color: #074F4F;
      margin-bottom: 10px;
    }
    .al-input-wrap {
      position: relative;
    }
    .al-input {
      width: 100%;
      height: 52px;
      padding: 0 18px;
      font-family: 'Inter', sans-serif;
      font-size: 14px;
      font-weight: 300;
      color: #2d2d2d;
      background: #FAF7F2;
      border: 1px solid transparent;
      border-radius: 0;
      outline: none;
      transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
      -webkit-appearance: none;
    }
    .al-input:focus {
      background: #fff;
      border-color: #C6A769;
      box-shadow: 0 0 0 3px rgba(198,167,105,0.06);
    }
    .al-input::placeholder {
      color: #b5b5b5;
      font-weight: 300;
    }
    .al-eye {
      position: absolute;
      right: 14px; top: 50%;
      transform: translateY(-50%);
      background: none; border: none;
      cursor: pointer;
      color: #b5b5b5;
      padding: 4px;
      display: flex; align-items: center;
      transition: color 0.3s;
    }
    .al-eye:hover { color: #074F4F; }

    /* error */
    .al-error {
      font-family: 'Inter', sans-serif;
      font-size: 12px;
      color: #b33;
      background: rgba(187,51,51,0.04);
      border-left: 2px solid #C6A769;
      padding: 12px 16px;
      margin-bottom: 20px;
      line-height: 1.5;
    }

    /* forgot */
    .al-forgot-row {
      display: flex;
      justify-content: flex-end;
      margin-top: -12px;
      margin-bottom: 28px;
    }
    .al-forgot {
      font-family: 'Inter', sans-serif;
      font-size: 11px; font-weight: 400;
      color: #C6A769;
      text-decoration: none;
      position: relative;
      padding-bottom: 2px;
    }
    .al-forgot::after {
      content: '';
      position: absolute;
      bottom: 0; left: 0;
      width: 100%; height: 1px;
      background: #C6A769;
      transform: scaleX(0);
      transform-origin: right;
      transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .al-forgot:hover::after {
      transform: scaleX(1);
      transform-origin: left;
    }

    /* submit */
    .al-submit {
      width: 100%;
      height: 52px;
      font-family: 'Inter', sans-serif;
      font-size: 10px; font-weight: 500;
      letter-spacing: 3.5px;
      text-transform: uppercase;
      color: #074F4F;
      background: #C6A769;
      border: none; cursor: pointer;
      position: relative; overflow: hidden;
      transition: transform 0.2s;
    }
    .al-submit::before {
      content: '';
      position: absolute; inset: 0;
      background: #fff;
      transform: translateY(101%);
      transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .al-submit:hover::before { transform: translateY(0); }
    .al-submit span { position: relative; z-index: 1; }
    .al-submit:active { transform: scale(0.98); }

    /* divider */
    .al-divider {
      display: flex;
      align-items: center;
      gap: 20px;
      margin: 28px 0;
    }
    .al-divider-line {
      flex: 1; height: 1px;
      background: rgba(7,79,79,0.06);
    }
    .al-divider-text {
      font-family: 'Inter', sans-serif;
      font-size: 9px; font-weight: 400;
      letter-spacing: 3px;
      text-transform: uppercase;
      color: #b5b5b5;
    }

    /* google */
    .al-google { display: flex; justify-content: center; }

    /* redirect */
    .al-redirect {
      text-align: center;
      margin-top: 32px;
      font-family: 'Inter', sans-serif;
      font-size: 12px;
      font-weight: 300;
      color: #8a8a8a;
    }
    .al-redirect a {
      color: #074F4F;
      font-weight: 500;
      text-decoration: none;
      margin-left: 4px;
      position: relative;
      padding-bottom: 1px;
    }
    .al-redirect a::after {
      content: '';
      position: absolute;
      bottom: 0; left: 0;
      width: 100%; height: 1px;
      background: #074F4F;
      transform: scaleX(0);
      transform-origin: right;
      transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .al-redirect a:hover::after {
      transform: scaleX(1);
      transform-origin: left;
    }

    /* responsive */
    @media (max-width: 1024px) {
      .al-nav-links, .al-nav-auth { display: none; }
      .al-nav-toggle { display: flex; }
      .al-nav-mobile { display: flex; }
      .al-f-grid { grid-template-columns: repeat(2, 1fr); }
    }
    @media (max-width: 900px) {
      .al-layout {
        grid-template-columns: 1fr;
        gap: 48px;
        padding: 40px 24px;
      }
      .al-brand { text-align: center; }
      .al-brand-quote { max-width: 100%; }
      .al-brand-line { margin-left: auto; margin-right: auto; }
      .al-card { padding: 40px 32px; }
      .al-nav-inner { padding: 20px 24px; }
      .al-footer { padding: 60px 24px 24px; }
    }
    @media (max-width: 520px) {
      .al-brand h1 { font-size: 36px; }
      .al-card { padding: 36px 24px; }
      .al-f-grid { grid-template-columns: 1fr; }
    }
  `;

  return (
    <div>
      <style>{css}</style>

      <TransitionOverlay
        active={showTransition || googleTransition}
        onComplete={handleTransitionComplete}
      />

      {/* NAV */}
      <nav className="al-nav">
        <div className="al-nav-inner">
          <a href="/" className="al-nav-logo">Aware</a>
          <ul className="al-nav-links">
            <li><a href="/">Acasă</a></li>
            <li><a href="/despre-noi">Despre noi</a></li>
            <li><a href="/servicii">Servicii</a></li>
            <li><a href="/evenimente">Evenimente</a></li>
            <li><a href="/#contact">Contact</a></li>
          </ul>
          <div className="al-nav-auth">
            <a href="/register" className="al-nav-reg"><span>Înregistrare</span></a>
          </div>
          <button className={"al-nav-toggle" + (mobileOpen ? " open" : "")} onClick={() => setMobileOpen((o) => !o)} aria-label="Meniu">
            <span></span><span></span><span></span>
          </button>
        </div>
        <div className={"al-nav-mobile" + (mobileOpen ? " open" : "")}>
          <ul className="al-nav-mobile-links">
            <li><a href="/">Acasă</a></li>
            <li><a href="/despre-noi">Despre noi</a></li>
            <li><a href="/servicii">Servicii</a></li>
            <li><a href="/evenimente">Evenimente</a></li>
            <li><a href="/#contact">Contact</a></li>
          </ul>
          <div className="al-nav-mobile-auth">
            <a href="/register" className="al-nav-reg"><span>Înregistrare</span></a>
          </div>
        </div>
      </nav>
      <div className={"al-nav-mobile-scrim" + (mobileOpen ? " open" : "")} onClick={() => setMobileOpen(false)} />
      <div className={"al-scene" + (loaded ? " loaded" : "")}>
        <div className="al-grain" />

        <div className="al-layout">
          {/* LEFT: BRAND */}
          <div className="al-brand">
            <div className="al-brand-tag">Spațiul tău sigur</div>
            <h1>Bine ai<br />revenit.</h1>
            <div className="al-brand-line" />
            <p className="al-brand-quote">
              „Fiecare pas spre conștientizare este un pas spre vindecare."
            </p>
            <div className="al-brand-author">— Aware</div>
          </div>

          {/* RIGHT: FORM */}
          <div className="al-form-wrap">
            <div className="al-card">
              <div className="al-card-head">
                <h2>Autentificare</h2>
                <p>Accesează contul tău Aware</p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="al-field">
                  <label className="al-label">Email</label>
                  <div className="al-input-wrap">
                    <input
                      className="al-input"
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="exemplu@email.com"
                      required
                    />
                </div>
                </div>

                <div className="al-field">
                  <label className="al-label">Parolă</label>
                  <div className="al-input-wrap">
                    <input
                      className="al-input"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="••••••••"
                      required
                      style={{ paddingRight: 44 }}
                    />
                    <button
                      type="button"
                      className="al-eye"
                      onClick={() => setShowPassword(!showPassword)}
                      tabIndex={-1}
                      aria-label={showPassword ? "Ascunde parola" : "Arată parola"}
                    >
                      {showPassword ? (
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                          <line x1="1" y1="1" x2="23" y2="23"/>
                        </svg>
                      ) : (
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                          <circle cx="12" cy="12" r="3"/>
                        </svg>
                      )}
                    </button>
                  </div>

                </div>

                {error && <div className="al-error">{error}</div>}

                <div className="al-forgot-row">
                  <a className="al-forgot" href="/reset-password">Ai uitat parola?</a>
                </div>

                <button type="submit" className="al-submit">
                  <span>Autentifică-te</span>
                </button>
              </form>

              <div className="al-divider">
                <span className="al-divider-line" />
                <span className="al-divider-text">sau</span>
                <span className="al-divider-line" />
              </div>

              <div className="al-google">
                <GoogleLogin
                  onSuccess={handleGoogleLogin}
                  onError={() => console.log("Eroare la autentificarea cu Google")}
                  type="standard"
                  theme="outline"
                  size="large"
                  text="signin_with"
                  shape="pill"
                  logo_alignment="left"
                />
              </div>

              <div className="al-redirect">
                Nu ai un cont?
                <a href="/register">Înregistrează-te aici</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="al-footer">
        <div className="al-f-inner">
          <div className="al-f-grid">
            <div className="al-f-brand">
              <div className="al-f-brand-name">Aware</div>
              <p>Un spațiu sigur pentru conștientizare, echilibru și sprijin emoțional.</p>
              <div className="al-f-social">
                <a href="#">Ig</a>
                <a href="#">Fb</a>
                <a href="#">Tk</a>
              </div>
            </div>
            <div className="al-f-col">
              <h5>Servicii</h5>
              <ul>
                <li><a href="#">Terapie Individuală</a></li>
                <li><a href="#">Terapie de Cuplu</a></li>
                <li><a href="#">Familie &amp; Parenting</a></li>
                <li><a href="#">Anxietate &amp; Depresie</a></li>
              </ul>
            </div>
            <div className="al-f-col">
              <h5>Terapeuți</h5>
              <ul>
                <li><a href="#">Alexandra Strambeanu</a></li>
                <li><a href="#">Luna Cosmari</a></li>
                <li><a href="#">Bianca Istratescu</a></li>
                <li><a href="#">Kathrin Moculity</a></li>
              </ul>
            </div>
            <div className="al-f-col">
              <h5>Aware</h5>
              <ul>
                <li><a href="/despre-noi">Despre noi</a></li>
                <li><a href="/#contact">Contact</a></li>
                <li><a href="/evenimente">Evenimente</a></li>
                <li><a href="/blog">Blog</a></li>
              </ul>
            </div>
          </div>
          <div className="al-f-divider"></div>
          <div className="al-f-bottom">
            <span>© 2025 Aware — Centru de Psihoterapie</span>
            <div>
              <a href="/conditii">Termeni</a>
              <a href="/confidentialitate">Confidențialitate</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Login;
